import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Fab } from '@material-ui/core';
import BarChartIcon from '@material-ui/icons/BarChart';
import { toggleSwitch } from '../../actions/index';
import { ToggleActions } from '../../constants/constants';

const MetricsButton = ({ metrics, popUpMenu, whatsappObservationsPopup, toggleSwitch }) => {
    const handleClick = () => {
        toggleSwitch(ToggleActions.METRICS);
    };

    const isEmbedMode = typeof window !== 'undefined' && window.embed === true;
    const shouldHide = popUpMenu.show || whatsappObservationsPopup.show || metrics;

    if (isEmbedMode || shouldHide) return null;

    return (
        <Fab
            size="medium"
            className="metrics-fab"
            onClick={handleClick}
            title="Ver Métricas"
        >
            <BarChartIcon />
        </Fab>
    );
};

function mapStateToProps(state) {
    return {
        metrics: state.switches.metrics,
        popUpMenu: state.popUpMenu,
        whatsappObservationsPopup: state.whatsappObservations.popup,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleSwitch,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MetricsButton);
